// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Recipes-List-__List___1EY1s","table-header":"app-pages-Ingredient-Recipes-List-__List___2iC_M","table-content-wrapper":"app-pages-Ingredient-Recipes-List-__List___3QnFI","table-content":"app-pages-Ingredient-Recipes-List-__List___3oXAZ","selected":"app-pages-Ingredient-Recipes-List-__List___1JRWH","parentRow":"app-pages-Ingredient-Recipes-List-__List___2hRlv"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Ingredient/Recipes/List/List.css
// module id = 2114
// module chunks = 0